var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100"},[(
      (_vm.merchant.id &&
        _vm.merchant.merchant_type == 'hotel' &&
        _vm.no_loading_screen) ||
      (_vm.merchant.id &&
        _vm.merchant.is_special_merchant &&
        _vm.current_route.meta.is_special_merchant)
    )?[_c('router-view')]:[(_vm.is_load)?_c('div',{staticClass:"py-4"},[_c('loader')],1):[(_vm.error != '')?_c('warning-box',{attrs:{"title":"Something wrong","body":_vm.error}}):[(_vm.no_wrapper_page)?_c('div',{staticClass:"w-100"},[_c('router-view')],1):_c('div',{staticClass:"w-100"},[(
              _vm.merchant.merchant_type == 'ticket' && _vm.merchant.theme == 'ZOO'
            )?[_c('router-view')]:_c('b-row',{staticClass:"justify-content-center",attrs:{"no-gutters":""}},[_c('b-col',{staticClass:"fit-to-screen bg-white",class:{ 'pb-60px': _vm.merchant.merchant_type == 'ticket' },attrs:{"cols":"12","sm":"8","md":"6","lg":"4","xl":"4"}},[_c('router-view'),_vm._v(" "),(_vm.merchant.merchant_type == 'ticket')?_c('bottom-navbar'):_vm._e()],1)],1)],2)]]]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c41f81e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/general/index.vue
// module id = null
// module chunks = 